
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getOrderCheckList, checkOrderPass, orderCheckClose } from '@/api/orderCheck';

import { IPagination } from '@/types';
import { OrderCheckStage } from '@/types/orderCheck';
import { UserModule } from '@/store/modules/user';

import dialogImgLarge from '@/components/ImgLarge/index.vue';
import eventBus from '@/utils/eventBus';

@Component({
  name: 'OrderCheckList',
  components: {
    dialogImgLarge
  }
})
export default class extends Vue {
  private listLoading = false
  private orderList = []

  @Prop({
    type: Number,
    default: OrderCheckStage.PROGRESS,
    required: true,
    validator: (value:any) => OrderCheckStage[value] !== undefined
  })
  private stage!: OrderCheckStage;

  // private orderCheckParams: any = {
  //   user_id: UserModule.getUserId,
  //   company_id: UserModule.getCompanyId,
  //   page: 1,
  //   size: 10
  // }
  // @Watch('orderCheckParams', { deep: true, immediate: true })
  // onParamsChange() {
  //   // 不在乎哪个变了，只要变了，就要重新请求数据
  //   this.getList();
  // }

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  created() {
    this.getList();
    // 当搜索组件出发这个事件后，刷新列表
    eventBus.$on('orderCheckOrderSearch', this.getList);
  }

  beforeDestroy() {
    // 在离开页面的时候注销掉该eventBus的事件，否则会在多个页面中重复请求
    eventBus.$off('orderCheckOrderSearch', this.getList);
  }

  /**
   * 获取订单列表
   */
  getList(searchParams?: any) {
    this.listLoading = true;
    if (searchParams) {
      this.pagination.currentPage = 1;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      stage: this.stage,
      // ...this.orderCheckParams,
      ...searchParams
    };
    getOrderCheckList(params).then(res => {
      const data = res.data;
      if (data !== null) {
        this.pagination.currentPage = parseInt(data.page_current);
        this.pagination.total = parseInt(data.count);
        this.pagination.pageSize = parseInt(data.page_size);
        this.orderList = data.list;
        for (var i = 0; i < this.orderList.length; i++) {
          (this.orderList[i]as any).btn_show = this.stage === OrderCheckStage.PROGRESS;
        }
      } else {
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.orderList = [];
      }
      this.listLoading = false;
    }).catch(err => {
      this.listLoading = false;
      let msg = err.msg;
    });
  }

  getTagsHtml(r:any) {
    let kind = ''; let kindType = ''; let plain = 'plain';
    if (parseInt(r.order.order_type) === 1) {
      kind = '其他';
      kindType = 'warning';
    } else if (parseInt(r.order.order_type) === 2) {
      kind = '维保';
      kindType = 'success';
    } else if (parseInt(r.order.order_type) === 3) {
      kind = '安装';
      kindType = 'danger';
    } else if (parseInt(r.order.order_type) === 4) {
      kind = '巡检';
      kindType = '';
    } else {
      kind = '维保';
      kindType = 'success';
    }

    let charge = ''; let darkplain = 'dark';
    if (parseInt(r.order_service.charge) === 1) {
      charge = '收费';
    }

    let expedited = '';
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = '加急';
    }

    // 2019-05-23 迭代 订单排位
    var ranking = '';
    if (parseInt(r.order_service.is_ranking) === 1) {
      var rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + '号';
      }
    }

    // 审核标识
    let check = '';
    if (parseInt(r.order.check_state) === 11 || parseInt(r.order.check_state) === 51) {
      check = '审核';
    }

    return [{
      type: kindType, label: kind, plain: plain
    }, {
      type: 'danger', label: charge, plain: darkplain
    }, {
      type: 'danger', label: expedited, plain: darkplain
    }, {
      type: 'danger', label: ranking, plain: darkplain
    }, {
      type: 'warning', label: check, plain: darkplain
    }];
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  // arraySpanMethod(IOrderColspan:any) {
  //   if (IOrderColspan.columnIndex === 0) {
  //     return [1, 8];
  //   } else if (IOrderColspan.columnIndex === 1 || IOrderColspan.columnIndex === 2 || IOrderColspan.columnIndex === 3 || IOrderColspan.columnIndex === 4 || IOrderColspan.columnIndex === 5 || IOrderColspan.columnIndex === 6 || IOrderColspan.columnIndex === 7) {
  //     return [0, 0];
  //   }
  // }

  // arraySpanMethodExpand(IOrderColspan: any) {
  //   if (IOrderColspan.columnIndex === 8 - 2) {
  //     return [1, 2];
  //   } else if (IOrderColspan.columnIndex === 8 - 1) {
  //     return [0, 0];
  //   }
  // }

  private dialogOrderDetailVisible = false
  private detail = {
    order: {
      reminder: {}
    },
    order_service: { transfer_out_from: {} },
    order_quote: {}
  }
  detailHandle(val:any, index:number) {
    let routeData = this.$router.resolve({
      path: '/order/orderToDetail',
      query: {
        order_service_id: val.order_service.id,
        orderId: val.order.id,
        isCheckOrder: '1',
        showComplaintBtn: '0',
        tabName: index === 2 ? 'schedule' : 'infor'
      }
    });
    window.open(routeData.href);
  }

  checkOrderPass(val:any) {
    this.$prompt('请输入备注', '订单通过', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      // inputPattern: /^.{1,100}$/,
      inputErrorMessage: '请输入1-100字符'
    }).then(({ value }: any) => {
      let p = {};
      (p as any).user_id = UserModule.getUserId;
      (p as any).company_id = UserModule.getCompanyId;
      (p as any).user_name = UserModule.getUserName;
      (p as any).order_id = val.order.id;
      (p as any).remark = value;
      checkOrderPass(p).then(res => {
        this.getList();
        this.showSuccessMsg('操作成功');
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }).catch(() => {
      // this.$message({
      //   type: 'info',
      //   message: '取消输入'
      // });
    });
  }

  orderCheckClose(val:any) {
    this.$prompt('请输入备注', '订单驳回', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /^.{1,100}$/,
      inputErrorMessage: '请输入1-100字符'
    }).then(({ value }: any) => {
      let p = {};
      (p as any).user_id = UserModule.getUserId;
      (p as any).company_id = UserModule.getCompanyId;
      (p as any).user_name = UserModule.getUserName;
      (p as any).order_id = val.order.id;
      (p as any).remark = value;
      orderCheckClose(p).then(res => {
        this.getList();
        this.showSuccessMsg('操作成功');
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }).catch(() => {
      // this.$message({
      //   type: 'info',
      //   message: '取消输入'
      // });
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
